import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { LotItem } from '../../../../models/inventory/lot-item';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-adjust-weight',
  templateUrl: './adjust-weight.component.html',
  styleUrl: './adjust-weight.component.scss',
})
export class AdjustWeightComponent extends BaseModalComponent<number | null> implements OnInit {
  @Input() MaxWeight = 0;
  isLoading = false;
  submittedForm = false;
  blockSaveButton = false;
  manualWeightValue = 0;

  itemInventoryFormGroup: FormGroup = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
  });

  constructor(
    injector: Injector,
    private messageService: MessageService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    console.log('Max weight:', this.MaxWeight);
  }

  onSave() {
    this.submittedForm = true;

    // Validar que el peso sea mayor a 0
    if (this.manualWeightValue <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Weight must be greater than 0',
        key: 'br',
        life: 2500,
      });
      return;
    }

    // Validar que el peso no sea mayor al MaxWeight
    if (this.MaxWeight > 0 && this.manualWeightValue > this.MaxWeight) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Weight cannot exceed ${this.MaxWeight} lbs`,
        key: 'br',
        life: 2500,
      });
      return;
    }

    // Cerrar el modal y retornar el valor
    this.close({ action: 'save', data: this.manualWeightValue });
  }

  onClose() {
    this.close({ action: 'close', data: null });
  }

  returnWeightOfCurrentStation() {
    return 0;
  }
}
